import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface PlannerUpdateWarningModalProps {
  isOpen: boolean;
  handleClose: () => void;
  totalEventCount: number;
  handleConfirmUpdate: () => void;
}

export const PlannerUpdateWarningModal = ({
  isOpen,
  handleClose,
  totalEventCount,
  handleConfirmUpdate,
}: PlannerUpdateWarningModalProps) => {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Update contact across all events?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This contact is linked to {totalEventCount} events. Your changes will
          update their info across all of them.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleConfirmUpdate}
          variant="contained"
          color="primary"
        >
          Update contact
        </Button>
      </DialogActions>
    </Dialog>
  );
};
